import React from 'react';
import PropTypes from 'prop-types';
import {Route, Switch} from 'react-router-dom';
import Logout from 'pages/Logout';
import ErrorMessage from 'common/components/ErrorMessage';
import UploadingFilePopUp from 'common/components/UploadingFilePopUp';
import CompleteInspectionPage from '../pages/CompleteInspectionPage';
import {pathnames as P} from 'common/constants/pathnames';
import {routes as auth} from './Auth/Auth';
import AuthGuard from './AuthGuard';
import GuestGuard from './GuestGuard';
import ProtectedRoute from '../common/components/ProtectedRoute';
import {shallowEqual, useSelector} from 'react-redux';
import MainMenu from '../pages/MainMenu';
import InspectedListPage from '../pages/InspectedList';
import InspectionFormPage from '../pages/FormPage';
import InspectedFirmPage from '../pages/InspectedFirm';
import EstimatesRepositoryPage from '../pages/EstimatesRepository';
import DocumentsAndReferencesPage from '../pages/DocumentsAndReferencesPage';
import Tasks from '../pages/Tasks';
import InspectionOtherPage from "../pages/InspectionOtherPage";
import AppraisalsPage from "../pages/Appraisals";
import TaxAuthorityPage from "../pages/TaxAuthority";

const Root = () => {
  const {allowInspectionsShare, firmInspectionsAccess} = useSelector(state => state.user, shallowEqual);
  const disableEstimatesRepo = !allowInspectionsShare || !firmInspectionsAccess;
  const disableEstimatesDatabase = !firmInspectionsAccess;

  const routes = [
    {
      path: P.INSPECTION,
      exact: false,
      component: InspectionFormPage,
      allow: true
    },
    {
      path: P.INSPECTED_LIST,
      exact: false,
      component: InspectedListPage,
      allow: true
    },
    {
      path: P.DOCUMENTS_AND_REFERENCES,
      exact: false,
      component: DocumentsAndReferencesPage,
      allow: true
    },
    {
      path: P.ESTIMATES_DATABASE,
      exact: false,
      component: InspectedFirmPage,
      allow: !disableEstimatesDatabase
    },
    {
      path: P.ESTIMATES_REPOSITORY,
      exact: false,
      component: EstimatesRepositoryPage,
      allow: !disableEstimatesRepo
    },
    {
      path: P.TASKS,
      exact: false,
      component: Tasks,
      allow: true
    },
    {
      path: P.APPRAISALS,
      exact: false,
      component: AppraisalsPage,
      allow: true
    },
    {
      path: P.TAX_AUTHORITY,
      exact: false,
      component: TaxAuthorityPage,
      allow: true
    },
    {
      path: P.INSPECTION_OTHER,
      exact: false,
      component: InspectionOtherPage,
      allow: true
    },
    {
      path: P.MAIN_MENU,
      exact: false,
      component: MainMenu,
      allow: true
    },
  ];

  return (
    <>
      <Switch>
        <Route path={P.AUTH_LOGOUT} exact component={Logout}/>
        <Route path={P.COMPLETE_INSPECTION} exact component={CompleteInspectionPage}/>
        <Route path={P.AUTH}>
          <GuestGuard>
            <Switch>
              {auth.map((route, ind) => <Route {...route} key={ind}/>)}
            </Switch>
          </GuestGuard>
        </Route>
        <Route path={P.MAIN_MENU}>
          <AuthGuard>
            <Switch>
              {routes.map((route, ind) => <ProtectedRoute key={ind} {...route} />)}
            </Switch>
          </AuthGuard>
        </Route>
      </Switch>
      <ErrorMessage/>
      <UploadingFilePopUp/>
    </>
  );
};

Root.propTypes = {
  accessToken: PropTypes.string,
  user: PropTypes.object,
};

export default Root;
